import React,{Component} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NumberFormat from 'react-number-format';
import Api from "../../../libraries/api";
import Button from '@material-ui/core/Button';
import {toast, ToastContainer} from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {history} from "../../../shared/configure-store";

require('dotenv').config();

class Points extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingCard: true,
            loadingButton: false,
            showDialog: false,
            errors: {},

            orderBy: 'id',
            sortedBy: '',
            searchBy: '',

            level: '',
            levels: [],
            rows: [],
            total: 0,
            perPage: 500,
            currentPage: 0,
            nextPage: 0,
            currentPageTable: 0,
            totalValue: 0,
            totalPoint: 0,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Gudangemas - Customer';

        Api.get('/admin/summary-point').then(resp => {
            if (resp.data) {
                this.setState({
                    totalValue: resp.data.totalValue,
                    totalPoint: resp.data.totalPoint,
                    loadingCard: false,
                });
            }

        }).catch(err => {
            console.log(err);
        });
        this.__fetchData(false);
    }
    __fetchData = update => {
        this.setState({
                loading: true
            }
        );
        let page = update ? 0 : this.state.currentPage;

        let params = {
            page: page,
            size: this.state.perPage,
            ['search-by']: this.state.searchBy,
            sort: [
                {
                    'column-name': this.state.orderBy,
                    'is-ascending': this.state.sortedBy === 'asc' ? true : false,
                }
            ],
        };

        Api.post('/admin/get-point-history', params).then(resp => {

            if(resp.data) {
                this.setState({
                    rows: resp.data.viewPointHistories,
                    total: resp.data.totalItems,
                    currentPageTable: resp.data.currentPage,
                    currentPage: resp.data.currentPage,
                    nextPage: resp.data.currentPage+1,
                    loading: false
                    }
                );
            }

        }).catch(err => {

            this.setState({
                    errors: err,
                    loading: false
                }
            );

        });

    };

    handleSearch = () => {
        this.__fetchData(true);
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(true);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if(val !== this.state.orderBy){
            sortedBy = 'asc';
        }else{
            if(sortedBy && sortedBy === 'asc' ){
                sortedBy = 'desc';
            }else{
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        });

    };

    handleChangeSelect (e, prop){

        this.setState({

            [prop]: e.target.value

        },() => {
            this.__fetchData(true);
        });

    };

    handleOpen = (row) => {
        this.setState({
            showDialog :true,
            idDelete: row['id-customer'],
            currDelete: row['full-name']+' '+row.email,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog :false,
        })
    };

    handleDelete = () => {

        if(this.state.idDelete) {
            let params = {
                listId: [this.state.idDelete]
            };

            Api.delete('/customer', params).then(resp => {

                this.setState({
                        showDialog: false,
                    }
                );

                this.showMessage(true, 'Customer berhasil dihapus');
                this.__fetchData(true);

            }).catch(err => {

                this.setState({
                        showDialog: false
                    }
                );

            });
        }
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage:newPage,
            currentPageTable:newPage,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage:parseInt(event.target.value, 10),
            currentPage:1,
            loading: true,
        },() => {
            this.__fetchData(false);
        });
    };

    handleGo = (link) => {

        history.push(link);
    };

    handleExport = ()  => {

        this.setState({
                loadingButton: true
            }
        );
        let params = {
            size: 500,
            page: this.state.currentPage,
            sort: [
                {
                    'column-name': this.state.orderBy,
                    'is-ascending': this.state.sortedBy === 'asc' ? true : false,
                }
            ],
        };
        Api.postEx('/admin/get-point-history/export/excel',params, 'blob').then(res=>{
            res.blob().then(resp => {

                let url = window.URL.createObjectURL(resp);
                let a = document.createElement('a');
                a.href = url;
                a.download = 'point-history.xlsx';
                a.click();
            });
            this.setState({
                loadingButton:false
            })
        });

    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Riwayat Poin</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Poin</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12">
                    <div className='row mt-3 mt-md-4'>
                        <div className='col-md-5'>
                            <div className='card-history'>
                                <p>Jumlah
                                    Total Value</p>
                                {this.state.loadingCard ? <i className="fa fa-spinner fa-spin"> </i> :
                                    <h5 className='big-num mb-0'>
                                        Rp <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={this.state.totalValue} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                    </h5>
                                }

                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='card-history blue'>
                                <p>Jumlah
                                    Poin</p>
                                {this.state.loadingCard ? <i className="fa fa-spinner fa-spin"> </i> :
                                    <h5 className='big-num mb-0'>
                                        <NumberFormat thousandSeparator={true} fixedDecimalScale={true}
                                                      value={this.state.totalPoint} displayType={'text'}
                                                      renderText={value => <span>{value}</span>}/>
                                    </h5>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>List Riwayat Poin</h2>
                            </div>
                            <div className="col-6 text-right">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.handleExport(true)}
                                    type='button'
                                >
                                    <i className="fas fa-file-excel mr-2"></i>
                                    Export {this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                                </Button>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton
                                                    aria-label="Search click"
                                                    onClick={this.handleSearch}
                                                >
                                                    <i className="fas fa-search"> </i>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[500]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPageTable}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                        <div className="table-list row">
                            <Table size="small" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('email')} >Customer Email
                                            {this.state.orderBy === 'email' && (
                                                <span className="icon-sort">{
                                                    this.state.sortedBy === 'asc' ? (
                                                        <i className="fas fa-sort-up"> </i>
                                                    ) : (
                                                        <i className="fas fa-sort-down"> </i>
                                                    )
                                                }</span>
                                            )}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('completeOrder')}>Complete Order
                                            {this.state.orderBy === 'completeOrder' && (
                                                <span className="icon-sort">{
                                                    this.state.sortedBy === 'asc' ? (
                                                        <i className="fas fa-sort-up"> </i>
                                                    ) : (
                                                        <i className="fas fa-sort-down"> </i>
                                                    )
                                                }</span>
                                            )}</TableCell>
                                        <TableCell>Nilai Digunakan</TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('point')}>Total Poin
                                            {this.state.orderBy === 'point' && (
                                                <span className="icon-sort">{
                                                    this.state.sortedBy === 'asc' ? (
                                                        <i className="fas fa-sort-up"> </i>
                                                    ) : (
                                                        <i className="fas fa-sort-down"> </i>
                                                    )
                                                }</span>
                                            )}</TableCell>
                                        <TableCell>Nilai Poin</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" className="py-5">
                                                <CircularProgress color="primary"  />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.length === 0 ? (
                                            <TableRow style={{ height: 33 * this.state.perPage}}>
                                                <TableCell colSpan={5} style={{ textAlign: "center" }}>Customer kosong</TableCell>
                                            </TableRow>
                                        ) : (
                                            this.state.rows.map(row => (
                                                <TableRow
                                                    key={row['id-customer']}
                                                    selected={row.selected}>
                                                    <TableCell>{row.email === null ? '' : row.email}</TableCell>
                                                    <TableCell>{row.completeOrder === null ? '' : row.completeOrder}</TableCell>
                                                    <TableCell>
                                                        Rp <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={row.usedValue} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                                    </TableCell>
                                                    <TableCell>{row.point === null ? '' : row.point}</TableCell>
                                                    <TableCell>
                                                        Rp <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={row.pointValue} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )
                                    )}

                                </TableBody>
                            </Table>
                        </div>

                    </div>

                    <TablePagination
                        rowsPerPageOptions={[500]}
                        component="div"
                        count={this.state.total}
                        rowsPerPage={this.state.perPage}
                        page={this.state.currentPageTable}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />

                </div>

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">PERHATIKAN! </DialogTitle>
                    <DialogContent>
                        <p>Apakah anda yakin akan menghapus <strong>{this.state.currDelete}</strong>?</p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleClose}>
                            Batal
                        </button>
                        <button className="btn btn-blue" onClick={this.handleDelete}>
                            Hapus
                        </button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />

            </div>
        )
    }
}

export default Points;
